import { render, staticRenderFns } from "./editor-dialog.vue?vue&type=template&id=79171c92"
import script from "./editor-dialog.vue?vue&type=script&lang=ts"
export * from "./editor-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports